import React from "react";
import { useTranslation } from "react-i18next";
import TopMenu from "../../components/TopMenu/TopMenu";
import useOcorrencia from "./useOcorrencia";
import "./Ocorrencia.css";

export default function Ocorrencia() {
  const { t } = useTranslation();
  const {
    dataAtual,
    nomeUsuario,
    place,
    mensagem,
    setPlace,
    setMensagem,
    enviarOcorrencia
  } = useOcorrencia();

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    enviarOcorrencia();
  };

  return (
    <div className="ocorrencia-page">
      <TopMenu />

      <main className="ocorrencia-content">
        <form className="ocorrencia-form" onSubmit={handleSubmit}>
          <div className="ocorrencia-scroll-container">
            <section className="ocorrencia-card">
              <p className="ocorrencia-meta">{dataAtual}</p>
              <p className="ocorrencia-meta">{nomeUsuario}</p>

              <label className="ocorrencia-field" htmlFor="place">
                <span className="ocorrencia-label">{t("pages.ocorrencia.cidadeLabel")}</span>
                <input
                  className="ocorrencia-input"
                  id="place"
                  onChange={(event) => setPlace(event.target.value)}
                  placeholder={t("pages.ocorrencia.cidadePlaceholder")}
                  type="text"
                  value={place}
                />
              </label>

              <label className="ocorrencia-field" htmlFor="mensagem">
                <span className="ocorrencia-label">{t("pages.ocorrencia.ocorrenciaLabel")}</span>
                <textarea
                  className="ocorrencia-textarea"
                  id="mensagem"
                  onChange={(event) => setMensagem(event.target.value)}
                  placeholder={t("pages.ocorrencia.ocorrenciaPlaceholder")}
                  rows={8}
                  value={mensagem}
                />
              </label>
            </section>
          </div>

          <div className="ocorrencia-actions">
            <button className="ocorrencia-button" type="submit">
              {t("pages.ocorrencia.enviar")}
            </button>
            <button
              className="ocorrencia-button"
              onClick={() => window.history.back()}
              type="button"
            >
              {t("pages.ocorrencia.cancelar")}
            </button>
          </div>
        </form>
      </main>
    </div>
  );
}

